// import React, { useState } from "react";
// import Dashboard from "../../core/Dashboard";
// import GymFilter from "../../components/gym-filter";
// import UserProfile from "../../components/user-profile";
// import SlideSideBar from "../../components/sidebar/components/slide-side-bar";
// import GlobalHeader from "../../components/header/header";
// import FloatingMenu from "../../components/floatingMenu";

// import "../employees/style.scss";
// import "./style.scss";

// import MembershipPlans from "./cards/membershipPlans";
// import WorkoutPlanner from "./cards/workoutPlanner";
// import NutritionPlanner from "./cards/nutritionPlanner";
// import MembershipOffers from "./cards/membershipOffers";
// import PhotoAdvertisement from "./cards/photoAdvertisement";
// import VideoAdvertisement from "./cards/videoAdvertisement";
// import TextAdvertisement from "./cards/textAdvertisement";

// import Gallery from "./cards/gallery";

// const SalesKiosk = () => {
//   const [selectedGym, setSelectedGym] = useState(null);

//   const handleSelectedGym = (selectedGym) => {
//     setSelectedGym(selectedGym);
//   };

//   return (
//     <Dashboard flag={-1}>

//       <div id="container" className="main-container main-container-auto"
//         style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch", height: "100vh",overflow: "hidden" }} >

//         {/* Header + dotted separator stay fixed at the top; scrolling begins only below this block */}
//         <div style={{ position: "sticky",top: 0,zIndex: 10,flexShrink: 0,background: "inherit"}} >
//           {window.innerWidth < 768 ? (

//             <GlobalHeader />
//           ) : (
//             <div
//               className="header-bar d-flex space-between kiosk-header-bar"
//               style={{ padding: "0"}}>
//               <div className="d-flex flex-item">
//                 <svg className="flex-item m-r-8" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M18.519 29.023L17.3256 30.0688C17.4678 30.2275 17.6408 30.3565 17.8345 30.4476C18.0281 30.5385 18.2383 30.59 18.4524 30.5987C18.6666 30.6073 18.8803 30.5729 19.0807 30.4979C19.2812 30.4227 19.4643 30.3083 19.6191 30.1614L18.519 29.023ZM23.0656 26.8873C23.3565 26.5945 23.5207 26.2011 23.5235 25.7902C23.5259 25.3796 23.367 24.984 23.08 24.6876C22.793 24.391 22.4007 24.2172 21.9865 24.2029C21.5721 24.1886 21.1685 24.3346 20.8613 24.6106L23.0656 26.8873ZM16.784 24.7032C16.6481 24.539 16.4802 24.4042 16.2903 24.3059C16.1005 24.2078 15.8927 24.1487 15.6792 24.1319C15.4657 24.1152 15.2511 24.1412 15.048 24.2086C14.845 24.2759 14.6577 24.3831 14.4975 24.524C14.3372 24.6645 14.2072 24.8358 14.1153 25.0275C14.0233 25.2191 13.9713 25.427 13.9623 25.6389C13.9534 25.8511 13.9876 26.0625 14.063 26.261C14.1385 26.4598 14.2535 26.641 14.4014 26.7947L16.784 24.7032ZM34.5584 21.5594C34.7006 21.7116 34.8712 21.8347 35.0613 21.9215C35.2512 22.0084 35.4566 22.0573 35.6657 22.0656C35.8745 22.0738 36.0831 22.041 36.2795 21.9694C36.4758 21.8977 36.6558 21.7884 36.8094 21.6478C36.9633 21.5071 37.0875 21.3378 37.1749 21.1497C37.2626 20.9615 37.3121 20.758 37.3203 20.5509C37.3286 20.3438 37.2955 20.1371 37.2234 19.9425C37.1509 19.7481 37.0407 19.5696 36.8988 19.4173L34.5584 21.5594ZM28.4297 15.7539C22.0888 15.7539 16.9284 20.8103 16.9284 27.0745H20.1138C20.1138 22.5778 23.8238 18.9102 28.4297 18.9102V15.7539ZM16.9284 27.0745V29.023H20.1138V27.0745H16.9284ZM19.6233 30.1614L23.0656 26.8873L20.8613 24.6106L17.419 27.8825L19.6233 30.1614ZM19.7124 27.9751L16.784 24.7032L14.4014 26.7947L17.3256 30.0688L19.7124 27.9751ZM36.8988 19.4173C35.8186 18.2596 34.5101 17.3362 33.0518 16.7057C31.5933 16.0751 30.0209 15.7511 28.4297 15.7539V18.9102C29.5816 18.9075 30.7199 19.1417 31.776 19.598C32.8321 20.0544 33.7809 20.723 34.5626 21.5615L36.8988 19.4173ZM38.143 26.6831L39.3325 25.6352C39.1901 25.4766 39.0167 25.3478 38.8231 25.257C38.6295 25.1661 38.419 25.1148 38.205 25.1064C37.9909 25.098 37.7772 25.1324 37.5769 25.2077C37.3765 25.2832 37.1934 25.3979 37.039 25.5448L38.143 26.6831ZM33.6008 28.8167C33.2959 29.1069 33.1201 29.5052 33.1119 29.9238C33.1034 30.3427 33.2632 30.7475 33.5561 31.0494C33.8491 31.3511 34.2509 31.5255 34.6736 31.5339C35.096 31.5421 35.5045 31.3837 35.8093 31.0935L33.6008 28.8167ZM39.8866 31.0051C40.1707 31.3049 40.5617 31.4829 40.9764 31.5015C41.3911 31.5198 41.7966 31.3772 42.1067 31.1037C42.4167 30.8301 42.6069 30.4476 42.6363 30.0374C42.6658 29.627 42.5326 29.2215 42.265 28.9073L39.8866 31.0051ZM22.0633 34.1762C21.7727 33.878 21.3753 33.7052 20.9571 33.6948C20.5388 33.6846 20.1334 33.8379 19.8282 34.1215C19.523 34.405 19.3428 34.7961 19.3263 35.2102C19.3097 35.6244 19.4585 36.0284 19.74 36.3351L22.0633 34.1762ZM28.1961 39.9521C34.5521 39.9521 39.7357 34.9021 39.7357 28.6316H36.5506C36.5506 33.1241 32.8278 36.7958 28.1961 36.7958V39.9521ZM39.7357 28.6316V26.6831H36.5506V28.6316H39.7357ZM37.039 25.5448L33.6008 28.8167L35.8093 31.0935L39.2453 27.8216L37.039 25.5448ZM36.9538 27.7332L39.8843 31.0031L42.265 28.9073L39.3325 25.6352L36.9538 27.7332ZM19.7379 36.3329C20.8225 37.4774 22.1326 38.3886 23.5871 39.0109C25.0417 39.633 26.6099 39.9527 28.1941 39.9501V36.7938C25.7667 36.7938 23.5859 35.7838 22.0612 34.174L19.7379 36.3329Z" fill="var(--extraDarkBlue)"/>
//                   <path d="M5 28.5C5 17.4221 5 11.8831 8.4404 8.4404C11.8855 5 17.4221 5 28.5 5C39.5779 5 45.117 5 48.5574 8.4404C52 11.8855 52 17.4221 52 28.5C52 39.5779 52 45.117 48.5574 48.5574C45.1192 52 39.5779 52 28.5 52C17.4221 52 11.8831 52 8.4404 48.5574C5 45.1192 5 39.5779 5 28.5Z" stroke="var(--extraDarkBlue)" strokeWidth="3.4"/>
//                 </svg>
//                 <div className="flex-item m-l-6">
//                   <p className="fs-26 font-weight-600 color-extra-dark-blue flex-item" style={{ lineHeight: "26px" }}>
//                     Sales Kiosk
//                   </p>
//                   <p className="fs-12 cursor-pointer m-t-2">Manage all your sales here</p>
//                 </div>
//               </div>
//               <div className="d-flex flex-item kiosk-header-actions">
//                 <div className="flex-item">
//                   <GymFilter getSelectedGym={handleSelectedGym} />
//                 </div>
//                 <UserProfile />
//                 {window.innerWidth < 1250 && window.innerWidth > 767 && <SlideSideBar />}
//               </div>
//             </div>
//           )}


//           {window.innerWidth >= 768 && <div className="dashboard-data-saperator m-t-16 flex-item" />}
//         </div>

//         <div
//           id="kiosk-scroll-area"
//           style={{ flex: 1,overflowY: "auto",minHeight: 0,}}>
//           <div className="kiosk-grid">
//             <MembershipPlans />
//             <WorkoutPlanner />
//             <NutritionPlanner />

//             <div className="kiosk-membership-offers">
//               <MembershipOffers selectedGym={selectedGym} />
//             </div>

//             <div className="kiosk-photo-ad">
//               <PhotoAdvertisement />
//             </div>
//             <div className="kiosk-video-ad">
//               <VideoAdvertisement />
//             </div>
//             <div className="kiosk-text-ad">
//               <TextAdvertisement />
//             </div>

//             <div className="kiosk-gallery">
//               <Gallery />
//             </div>
//           </div>
//         </div>
//       </div>


//       {window.innerWidth < 768 && <FloatingMenu selectedGym={selectedGym} />}
//     </Dashboard>
//   );
// };

// export default SalesKiosk;






import React, { useState, useEffect } from "react";
import Dashboard from "../../core/Dashboard";
import GymFilter from "../../components/gym-filter";
import UserProfile from "../../components/user-profile";
import SlideSideBar from "../../components/sidebar/components/slide-side-bar";
import GlobalHeader from "../../components/header/header";
import FloatingMenu from "../../components/floatingMenu";

import "../employees/style.scss";
import "./style.scss";

import MembershipPlans from "./cards/membershipPlans";
import WorkoutPlanner from "./cards/workoutPlanner";
import NutritionPlanner from "./cards/nutritionPlanner";
import MembershipOffers from "./cards/membershipOffers";
import PhotoAdvertisement from "./cards/photoAdvertisement";
import VideoAdvertisement from "./cards/videoAdvertisement";
import TextAdvertisement from "./cards/textAdvertisement";

import Gallery from "./cards/gallery";


const BREAKPOINT_MD = 768;
const BREAKPOINT_TABLET_MAX = 1250;


const useWindowWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

const SalesKiosk = () => {
  const [selectedGym, setSelectedGym] = useState(null);
  const windowWidth = useWindowWidth();

  const handleSelectedGym = (selectedGym) => {
    setSelectedGym(selectedGym);
  };

  return (
    <Dashboard flag={-1}>

      <div id="container" className="main-container main-container-auto"
        style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch", height: "100vh",overflow: "hidden" }} >

        
        <div style={{ position: "sticky",top: 0,zIndex: 1,flexShrink: 0,background: "inherit"}} >
          {windowWidth < BREAKPOINT_MD ? (

            <GlobalHeader />
          ) : (
            <div
              className="header-bar d-flex space-between kiosk-header-bar"
              style={{ padding: "0"}}>
              <div className="d-flex flex-item">
                <svg className="flex-item m-r-8" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.519 29.023L17.3256 30.0688C17.4678 30.2275 17.6408 30.3565 17.8345 30.4476C18.0281 30.5385 18.2383 30.59 18.4524 30.5987C18.6666 30.6073 18.8803 30.5729 19.0807 30.4979C19.2812 30.4227 19.4643 30.3083 19.6191 30.1614L18.519 29.023ZM23.0656 26.8873C23.3565 26.5945 23.5207 26.2011 23.5235 25.7902C23.5259 25.3796 23.367 24.984 23.08 24.6876C22.793 24.391 22.4007 24.2172 21.9865 24.2029C21.5721 24.1886 21.1685 24.3346 20.8613 24.6106L23.0656 26.8873ZM16.784 24.7032C16.6481 24.539 16.4802 24.4042 16.2903 24.3059C16.1005 24.2078 15.8927 24.1487 15.6792 24.1319C15.4657 24.1152 15.2511 24.1412 15.048 24.2086C14.845 24.2759 14.6577 24.3831 14.4975 24.524C14.3372 24.6645 14.2072 24.8358 14.1153 25.0275C14.0233 25.2191 13.9713 25.427 13.9623 25.6389C13.9534 25.8511 13.9876 26.0625 14.063 26.261C14.1385 26.4598 14.2535 26.641 14.4014 26.7947L16.784 24.7032ZM34.5584 21.5594C34.7006 21.7116 34.8712 21.8347 35.0613 21.9215C35.2512 22.0084 35.4566 22.0573 35.6657 22.0656C35.8745 22.0738 36.0831 22.041 36.2795 21.9694C36.4758 21.8977 36.6558 21.7884 36.8094 21.6478C36.9633 21.5071 37.0875 21.3378 37.1749 21.1497C37.2626 20.9615 37.3121 20.758 37.3203 20.5509C37.3286 20.3438 37.2955 20.1371 37.2234 19.9425C37.1509 19.7481 37.0407 19.5696 36.8988 19.4173L34.5584 21.5594ZM28.4297 15.7539C22.0888 15.7539 16.9284 20.8103 16.9284 27.0745H20.1138C20.1138 22.5778 23.8238 18.9102 28.4297 18.9102V15.7539ZM16.9284 27.0745V29.023H20.1138V27.0745H16.9284ZM19.6233 30.1614L23.0656 26.8873L20.8613 24.6106L17.419 27.8825L19.6233 30.1614ZM19.7124 27.9751L16.784 24.7032L14.4014 26.7947L17.3256 30.0688L19.7124 27.9751ZM36.8988 19.4173C35.8186 18.2596 34.5101 17.3362 33.0518 16.7057C31.5933 16.0751 30.0209 15.7511 28.4297 15.7539V18.9102C29.5816 18.9075 30.7199 19.1417 31.776 19.598C32.8321 20.0544 33.7809 20.723 34.5626 21.5615L36.8988 19.4173ZM38.143 26.6831L39.3325 25.6352C39.1901 25.4766 39.0167 25.3478 38.8231 25.257C38.6295 25.1661 38.419 25.1148 38.205 25.1064C37.9909 25.098 37.7772 25.1324 37.5769 25.2077C37.3765 25.2832 37.1934 25.3979 37.039 25.5448L38.143 26.6831ZM33.6008 28.8167C33.2959 29.1069 33.1201 29.5052 33.1119 29.9238C33.1034 30.3427 33.2632 30.7475 33.5561 31.0494C33.8491 31.3511 34.2509 31.5255 34.6736 31.5339C35.096 31.5421 35.5045 31.3837 35.8093 31.0935L33.6008 28.8167ZM39.8866 31.0051C40.1707 31.3049 40.5617 31.4829 40.9764 31.5015C41.3911 31.5198 41.7966 31.3772 42.1067 31.1037C42.4167 30.8301 42.6069 30.4476 42.6363 30.0374C42.6658 29.627 42.5326 29.2215 42.265 28.9073L39.8866 31.0051ZM22.0633 34.1762C21.7727 33.878 21.3753 33.7052 20.9571 33.6948C20.5388 33.6846 20.1334 33.8379 19.8282 34.1215C19.523 34.405 19.3428 34.7961 19.3263 35.2102C19.3097 35.6244 19.4585 36.0284 19.74 36.3351L22.0633 34.1762ZM28.1961 39.9521C34.5521 39.9521 39.7357 34.9021 39.7357 28.6316H36.5506C36.5506 33.1241 32.8278 36.7958 28.1961 36.7958V39.9521ZM39.7357 28.6316V26.6831H36.5506V28.6316H39.7357ZM37.039 25.5448L33.6008 28.8167L35.8093 31.0935L39.2453 27.8216L37.039 25.5448ZM36.9538 27.7332L39.8843 31.0031L42.265 28.9073L39.3325 25.6352L36.9538 27.7332ZM19.7379 36.3329C20.8225 37.4774 22.1326 38.3886 23.5871 39.0109C25.0417 39.633 26.6099 39.9527 28.1941 39.9501V36.7938C25.7667 36.7938 23.5859 35.7838 22.0612 34.174L19.7379 36.3329Z" fill="var(--extraDarkBlue)"/>
                  <path d="M5 28.5C5 17.4221 5 11.8831 8.4404 8.4404C11.8855 5 17.4221 5 28.5 5C39.5779 5 45.117 5 48.5574 8.4404C52 11.8855 52 17.4221 52 28.5C52 39.5779 52 45.117 48.5574 48.5574C45.1192 52 39.5779 52 28.5 52C17.4221 52 11.8831 52 8.4404 48.5574C5 45.1192 5 39.5779 5 28.5Z" stroke="var(--extraDarkBlue)" strokeWidth="3.4"/>
                </svg>
                <div className="flex-item m-l-6">
                  <p className="fs-26 font-weight-600 color-extra-dark-blue flex-item" style={{ lineHeight: "26px" }}>
                    Sales Kiosk
                  </p>
                  <p className="fs-12 cursor-pointer m-t-2">Manage all your sales here</p>
                </div>
              </div>
              <div className="d-flex flex-item kiosk-header-actions">
                <div className="flex-item">
                  <GymFilter getSelectedGym={handleSelectedGym} />
                </div>
                <UserProfile />
                {windowWidth < BREAKPOINT_TABLET_MAX && windowWidth > BREAKPOINT_MD - 1 && <SlideSideBar />}
              </div>
            </div>
          )}


          {windowWidth >= BREAKPOINT_MD && <div className="dashboard-data-saperator m-t-16 flex-item" />}
        </div>

        <div
          id="kiosk-scroll-area"
          style={{ flex: 1,overflowY: "auto",minHeight: 0,}}>
          <div className="kiosk-grid">
            <MembershipPlans />
            <WorkoutPlanner />
            <NutritionPlanner />

            <div className="kiosk-membership-offers">
              <MembershipOffers selectedGym={selectedGym} />
            </div>

            <div className="kiosk-photo-ad">
              <PhotoAdvertisement />
            </div>
            <div className="kiosk-video-ad">
              <VideoAdvertisement />
            </div>
            <div className="kiosk-text-ad">
              <TextAdvertisement />
            </div>

            <div className="kiosk-gallery">
              <Gallery />
            </div>
          </div>
        </div>
      </div>


      {windowWidth < BREAKPOINT_MD && <FloatingMenu selectedGym={selectedGym} />}
    </Dashboard>
  );
};

export default SalesKiosk;